import { INITIAL_DISCONT } from '../enums';

import type { ConsumerPrice, ResellerPrice } from 'ui/components';

function ifHasBothResellerAndConsumerDiscount(resellerDiscount: number, consumerDiscount: number) {
  return resellerDiscount > INITIAL_DISCONT && consumerDiscount > INITIAL_DISCONT;
}

function ifOnlyResellerHasDiscount(resellerDiscount: number, consumerDiscount: number) {
  return resellerDiscount > INITIAL_DISCONT && consumerDiscount === INITIAL_DISCONT;
}

export function getValueTag(
  resellerPrice: ResellerPrice,
  consumerPrice: ConsumerPrice,
  numericResult?: boolean,
): number {
  const resellerDiscount = resellerPrice?.discountPercentage || INITIAL_DISCONT;
  const consumerDiscount = consumerPrice?.percent || INITIAL_DISCONT;

  if (resellerDiscount === INITIAL_DISCONT && consumerDiscount === INITIAL_DISCONT) {
    return INITIAL_DISCONT;
  }

  if (ifHasBothResellerAndConsumerDiscount(resellerDiscount, consumerDiscount)) {
    return numericResult
      ? resellerPrice.discount || INITIAL_DISCONT
      : resellerPrice.discountPercentage || INITIAL_DISCONT;
  }

  if (ifOnlyResellerHasDiscount(resellerDiscount, consumerDiscount)) {
    return numericResult
      ? resellerPrice.discount || INITIAL_DISCONT
      : resellerPrice.discountPercentage || INITIAL_DISCONT;
  }

  return numericResult
    ? consumerPrice.discount || INITIAL_DISCONT
    : consumerPrice.percent || INITIAL_DISCONT;
}
